export interface KfsInputs {
  loanAmount: number | null;
  loanDate: Date | null;
  interestRate: number | null; // user enters as %, e.g. 12 for 12%
  grossWeight: number | null;
}

export interface KfsCalculatedValues {
  insuranceCharge: number; // field 6
  apr: number; // fields 7 & 16 (decimal, e.g. 0.12239)
  totalInterest: number; // field 11
  feeCharges: number; // field 12
  payableToRE: number; // field 13
  netDisbursement: number; // field 14
  totalAmountPayable: number; // field 15
  instalmentDueDates: Date[]; // 4 quarterly dates
}

export const KFS_CONSTANTS = {
  INSURANCE_RATE_PER_GRAM: 1,
  INSURANCE_TENURE_MONTHS: 12,
  FIXED_PROCESSING_FEE: 59,
  INSTALMENT_INTERVALS: [89, 179, 269, 359] as const,
} as const;
